import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-mall-channel-command",
  "use": "icon-soc-mall-channel-command-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-mall-channel-command\">\n<g fill=\"none\" stroke=\"currentColor\" stroke-width=\"48\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\n  <rect x=\"140\" y=\"160\" width=\"280\" height=\"200\" rx=\"36\" />\n  <rect x=\"604\" y=\"160\" width=\"280\" height=\"200\" rx=\"36\" />\n  <rect x=\"140\" y=\"664\" width=\"280\" height=\"200\" rx=\"36\" />\n  <rect x=\"604\" y=\"664\" width=\"280\" height=\"200\" rx=\"36\" />\n  <path d=\"M280 360v120h464V360M280 664V544h464v120\" />\n</g>\n<circle cx=\"280\" cy=\"260\" r=\"28\" fill=\"currentColor\" />\n<circle cx=\"744\" cy=\"260\" r=\"28\" fill=\"currentColor\" />\n<circle cx=\"280\" cy=\"764\" r=\"28\" fill=\"currentColor\" />\n<circle cx=\"744\" cy=\"764\" r=\"28\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-mall-channel-command.svg
// module id = 1vTX
// module chunks = 491